import {
  animate,
  animateChild,
  group,
  query,
  stagger,
  state,
  style,
  transition,
  trigger,
} from '@angular/animations';

export const GP_EASE = 'cubic-bezier(0.22, 1, 0.36, 1)';

/**
 * Hero copy + map panel: opacity 0 -> 1, translateY(28px) -> 0. Runs once.
 * `animateChild` lets the nested stat-card stagger run instead of being
 * swallowed by this parent transition.
 */
export const gpFade = trigger('gpFade', [
  state('hidden', style({ opacity: 0, transform: 'translateY(28px)' })),
  state('shown', style({ opacity: 1, transform: 'none' })),
  transition('hidden => shown', [
    group([
      animate(`480ms ${GP_EASE}`),
      query('@*', animateChild(), { optional: true }),
    ]),
  ]),
]);

/** Statistic cards land left to right once the hero is in view. */
export const gpStats = trigger('gpStats', [
  transition('hidden => shown', [
    query('.gp-stat', style({ opacity: 0, transform: 'translateY(22px)' }), {
      optional: true,
    }),
    query(
      '.gp-stat',
      stagger(70, [
        animate(`420ms ${GP_EASE}`, style({ opacity: 1, transform: 'none' })),
      ]),
      { optional: true }
    ),
  ]),
]);

/** Country chips reveal one after another as the grid scrolls in. */
export const gpCountries = trigger('gpCountries', [
  transition('hidden => shown', [
    query('.gp-country', style({ opacity: 0, transform: 'translateY(18px)' }), {
      optional: true,
    }),
    query(
      '.gp-country',
      stagger(45, [
        animate(`380ms ${GP_EASE}`, style({ opacity: 1, transform: 'none' })),
      ]),
      { optional: true }
    ),
  ]),
]);
